import React from 'react';
import styled from 'styled-components';
import Pattern from './Pattern';
import Ruler from '../patterngalleries/Ruler';

const RecoloredPatternPreview = ({ col, rows, imgSrc, children }) => {
    const PatternBox = styled.div`
        width: 400px;
        max-width: calc( 100% / ${col} );
        height: auto;
        margin: 0;
        padding: 0;
        order: 2;
        position: relative;
        line-height: 0;
    `;

    const FlexContainer = styled.div`
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        font-size: 90%;
    `;

    const HorizontalRuler = styled.div`
        width: 100%;
        order: 1;
        padding: 0;
        margin: 0;
    `;

    const buildRow = (col, imgSrc) => {
        const row = [];
        for (let i = 0; i < col; i++) {
            row.push(
                <PatternBox key={i} >
                    <Pattern src={imgSrc} col={col} />
                </PatternBox >);
        }
        return row;
    };

    const buildRows = (rows, col, imgSrc) => {
        const Rows = [];
        for (let i = 0; i < rows; i++) {
            Rows.push(buildRow(col, imgSrc));
        }
        return Rows;
    };


    return (
        <FlexContainer >
            <HorizontalRuler >
                <Ruler col={col} />
            </HorizontalRuler >
            {buildRows(rows, col, imgSrc)}
            {children}
        </FlexContainer >
    );
};

export default RecoloredPatternPreview;




// WEBPACK FOOTER //
// ./src/components/pattern/RecoloredPatternPreview.js